import axiosAuth from '../../../axiosMain';

async function index(company_id, data) {
  let response = await axiosAuth.post('/green_button/data/usage/' + company_id, data);
  return response.data.data;
}

export default {
  index,
};
